import { render } from "./PlaceDetail.vue?vue&type=template&id=fb942024&scoped=true"
import script from "./PlaceDetail.vue?vue&type=script&lang=js"
export * from "./PlaceDetail.vue?vue&type=script&lang=js"

import "./PlaceDetail.vue?vue&type=style&index=0&id=fb942024&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb942024"]])

export default __exports__